const DEBUG = false;

export const MAX_CART_ITEM    = 12;
export const MAX_QUANTITY     = 6;
const MAX_ENROLL_ITEM         = 2;
const DEFAULT_TAX_RATE        = 0.00; //our db only includes taxes for states we tax, rest are 0.00%
const DEFAULT_SHIPPING_COST   = 5.99;
const PREORDER_SHIPPING_COST  = 3.99;

function priceMap(sale_prices, store){
  return {
    'ynn': [sale_prices[0], 0.00, 0.00],
    'yyn': [sale_prices[0], store.second_book, 0.00],
    'yyy': [sale_prices[0], store.second_book, store.third_book],
    'nyy': [0.00, sale_prices[1], sale_prices[2]],
    'nyn': [0.00, sale_prices[1], 0.00],
    'nnn': [0.00, 0.00, 0.00]
  };
}

function getMembershipBundlePricing(sale_prices, store){
  if(store.bundle_pricing){ //special bundle pricing
    let sale_prices_1_3 = priceMap(sale_prices.slice(0, 3), store)[[0, 1, 2].map/*to cart items*/((p, i)=>sale_prices[i] ? 'y' : 'n').join('')];
    let sale_prices_3_12 = sale_prices.slice(3);
    return sale_prices_1_3.concat(sale_prices_3_12);
  } else
    return sale_prices;
}

function enrollPriceMap(store){
  return {
    'yn': [store.second_book, 0.00],
    'yy': [store.second_book, store.second_book ],
    'ny': [0.00, store.second_book ],
    'nn': [0.00, 0.00]
  };
}

function getPromoPricing(sale_prices, promo_items, promo_discount) {
  let computed_prices = sale_prices.map((item, i) => {
    // If discount is <= 1, it's a percentage; if it's > 1, it's a dollar amount
    let discounted_price = (promo_discount <= 1) ? (item * (1 - promo_discount)) : (item - promo_discount);
    if (item && promo_items[i] !== null) {
      // Return 0 if discounted_price is negative
      return (discounted_price >= 0) ? Number(discounted_price.toFixed(2)) : 0;
    }
    return item;
  });
  return computed_prices;
}

// product and cart must be obj { id: id, format: regular, bluray, large_print }
export function updateQuantity(product, cart, featured, store_bundle_pricing) {
    return cart.reduce((acc, c) => {
        let cartCount = acc.reduce( (a,b) => { return a + ( b ? b.quantity : 0) }, 0);
        let productMatch = (c && product.id === c.id && product.format === c.format);
        let isFeatured = featured.find(f=> c && f.id == c.id);
        let newCartCount = (c ? c.quantity : 0) - (productMatch ? product.quantity : 0) + cartCount;
        let truthiness = !store_bundle_pricing ?
          c && newCartCount <= MAX_CART_ITEM :
          c && !isFeatured && ((newCartCount <= MAX_CART_ITEM && acc[0] ) || (newCartCount < MAX_CART_ITEM && !acc[0] ));
        if (truthiness){
          if( productMatch ) c.quantity = product.quantity
          acc.push(c);
        }
        return acc;
    }, (!store_bundle_pricing ? [] : [ cart.find(c=>featured.find(f=> c && c.id == f.id)) || undefined ]));
}

// product and cart must be obj { id: id, format: regular, bluray, large_print }
export function addToCart(product, cart, featured, store_bundle_pricing) {
    cart.push(product || undefined);
    return cart.reduce((acc, c) => {
        let currentCartLength = acc.reduce( (a,b) => { return a + ( b ? b.quantity : 0) }, 0);
        let proposedCartLength = (c ? c.quantity : 0) + currentCartLength;
        let isFeatured = featured.find(f=> c && f.id == c.id);
        let truthiness = !store_bundle_pricing ?
          c && proposedCartLength <= MAX_CART_ITEM :
          c && !isFeatured && ((proposedCartLength <= MAX_CART_ITEM && acc[0] ) || (proposedCartLength < MAX_CART_ITEM && !acc[0] ));
        if (truthiness){
          let existingProductIndex = acc.findIndex(e=> e && e.id == c.id && e.format === c.format);
          if( existingProductIndex > -1 ){
            let existing = acc.splice(existingProductIndex, 1)[0];
            existing.quantity += product.quantity;
            acc.push(existing);
          }
          else acc.push(c);
        }
        return acc;
    }, (!store_bundle_pricing ? [] : [ cart.find(c=>featured.find(f=> c && c.id == f.id)) || undefined ]));
}

export function addToCartO(product, quantity, cart, featured, store_bundle_pricing) {
    return addToCart(
      { id: product.id, format: product.format, quantity: quantity },
      cart.map(p=> p ? { id: p.id, format: p.format, quantity: p.quantity } : 0),
      featured,
      store_bundle_pricing
    ).map/*back to objects*/(p=> p && p.id == product.id && p.format == product.format ? { ...product, quantity: quantity } :
      ( cart.find(c=> c && p ? c.id == p.id && c.format == p.format : false) ?
        { ...cart.find(c=> c && p ? c.id == p.id && c.format == p.format  : false), quantity: p.quantity } : undefined
      )
    );
}

export function removeFromCart(product, cart, featured, store_bundle_pricing) {
    return addToCart(undefined, cart.map(c=> c && c.id == product.id && c.format == product.format ? undefined : c), featured, store_bundle_pricing);
}

export function removeFromCartO(product, cart, featured, store_bundle_pricing) {
    return removeFromCart(
      { id: product.id, format: product.format },
      cart.map/*to ids*/(p=> p ? {id: p.id, format: p.format, quantity: p.quantity} : 0),
      featured,
      store_bundle_pricing).map/*back to objects*/(p=> p && p.id == product.id ? product : cart.find(c=>c ? p && c && c.id == p.id : false));
}

export function implodeCart(cart, promo_items){
  let newCart = [];
  let newPromoItems = [];
  cart.forEach( (c, i) => {
    let elmIndex = newCart.findIndex( x => x && c && x.id === c.id && x.format === c.format);
    if(!c){
      newCart.push(undefined);
      if(promo_items[i] !== undefined ) newPromoItems.push( promo_items[i] );
    } else if(elmIndex > -1){
      newCart[elmIndex].quantity++;
      newCart[elmIndex].creditArr.push( c.credit === true );
      newCart[elmIndex].subPrices.push( c.computed_price );
      newCart[elmIndex].computed_price += c.computed_price;
      if( newPromoItems[elmIndex] == null && promo_items[i] !== undefined ) newPromoItems[elmIndex] = promo_items[i];
    } else {
      newCart.push({
        ...c,
        quantity: 1,
        subPrices: [ c.computed_price ],
        creditArr: [ c.credit === true ]
      });
      if(promo_items[i] !== undefined ) newPromoItems.push( promo_items[i] );
    }
  });

  return [newCart, newPromoItems];
}

export function explodeCart(cart){
  let newCart = [];
  cart.forEach( c => c ?
    ( c.subPrices ?
      (c.subPrices.forEach( (sub, i) => newCart.push({...c, computed_price: sub, quantity: 1, credit: c.creditArr[i] }) )) :
      (new Array(c.quantity||1).fill(0).forEach( x => newCart.push({...c, computed_price: c.sale_price, quantity: 1, credit: false }) ))) :
    (newCart.push(undefined))
  );
  return newCart;
}

export function priceCart(cart, credits, customer, store, upgradingMember=null, promo=null) {
  let shipping = 0;
  let cart_prices = [];
  let preCreditTotal = 0;
  let tax_rate = DEFAULT_TAX_RATE;
  let promo_items = [];
  let itemCount = cart.filter( c => c ).length;
  let isEnrollment = (!customer || customer.status !== 'Active' || upgradingMember) ? true : false;

  if (customer && customer.tax_rates && customer.tax_rates[1] !== undefined) tax_rate = customer.tax_rates[1];

  if ( isEnrollment ) { //enrollment deal
    cart_prices = enrollPriceMap(store)[[0, 1].map/*to cart items*/((p, i)=>cart[i] ? 'y' : 'n').join('')];
  } else { //regular purchase
    let sale_prices = cart.map( x => x && x.sale_price ? x.sale_price : 0 );

    // membership promos applied based on whether store has bundle pricing or cart has promo
    if (promo) {
      // Determine if promo can be applied to item
      cart.forEach((oItem, i) => {
        if (oItem && !oItem.excludeFromPromos && oItem.format !== 'bluray' && (promo.clubs.indexOf(store.id) > -1 || oItem.promos.indexOf(promo.id) > -1)) {
          // Save db price and location in cart array
          if (oItem.format !== "regular") promo_items.push([oItem[oItem.format].price, i]);
          else promo_items.push([oItem.sale_price, i]);
        } else
          promo_items.push(null);
      });
      if (promo.type === 'DISCOUNT') {


        // Remove items that do not apply to promo
        // then Sort items that promo can apply to by price (most expensive first)
        let aPromoItemsByPrice = promo_items
          .filter((oItem, i) => { return oItem; })
          .sort((a, b) => { return b[0] - a[0]; });

        // If promo has minimum threshold of items, apply threshold to most expensive items first
        if (promo.minimum !== null) {
          let numItems = aPromoItemsByPrice.length;
          let minThresh = numItems - Math.floor(numItems / (promo.minimum + 1)) || 0;
          aPromoItemsByPrice.forEach((promoItem, i) => {
            if ( i < minThresh && promo_items[promoItem[1]] ) promo_items[promoItem[1]] = null;
          });
        }

        // If promo has maximum threshold of items, apply threshold to more expensive items first
        if (promo.maximum !== null && promo.maximum > 0) {
          let reversePrices = aPromoItemsByPrice.slice().reverse(); // slicing makes a real copy
          reversePrices.forEach((promoItem, i) => {
            if (i >= promo.maximum && promo_items[promoItem[1]]) promo_items[promoItem[1]] = null;
          });
        }

        // If promo hasn't been nulled out of list, indicate order in which discount is to be applied
        aPromoItemsByPrice.forEach((promoItem, i) => {
          if (promoItem && promo_items[promoItem[1]]) promo_items[promoItem[1]] = i;
        });

        cart_prices = getPromoPricing(sale_prices, promo_items, promo.discount);
      } else if (promo.type === 'TIER') {
        const prices = promo.prices.split(',').map(i => parseFloat(i));
        const minimum = promo.minimum || 1;
        // Unapply promo.
        cart_prices = sale_prices;
        const saved_promo_items = promo_items;
        promo_items = promo_items.map(_=> null);
        // Go through the prices, starting with the best, and find what we can apply
        for (let i = prices.length; i >= 0; i--) {
          if (saved_promo_items.filter(promoItem => promoItem && promoItem[0] > prices[i]).length >= (i  + minimum)) {
            const price = prices[i];
            cart_prices = sale_prices.map(oldPrice => oldPrice && price < oldPrice ? price : oldPrice);
            promo_items = saved_promo_items.map((promoItem, i) => promoItem && promoItem[0] > price ? i : null);
            break;
          }
        }
      }
    } else {
      cart_prices = getMembershipBundlePricing(sale_prices, store);
    }

    preCreditTotal = cart_prices.reduce((t, p) => t + p, 0);
    if(store.type === "Neglite") {
      //book must be credit eligible to apply a credit to it
      let credit_eligible = cart.map((x, i) => { return (x && cart_prices[i] <= store.credit_eligible) ? 1 : 0 });
      if (DEBUG) console.log('credit_eligible: ', credit_eligible);
      cart_prices = cart_prices.map/*to credit count*/((p, i)=> credits[i] === 1 && credit_eligible[i] === 1 ? 0 : p );
    }
  }

  let total = cart_prices.reduce((t, p)=> t + p, 0 );
  // NONT BUNDLE CLUBS (NEG OP OR NEGLITE) have shipping cost if fewer then 3 books or cost under 35
  // other BUNDLE PRICING CLUBS get free shipping on 3 books or more
  if ( (isEnrollment || store.bundle_pricing) && itemCount <= 2 )
    shipping = DEFAULT_SHIPPING_COST;
  else if( !isEnrollment && !store.bundle_pricing && (itemCount <= 2 || preCreditTotal < 35 ))
    shipping = DEFAULT_SHIPPING_COST;

  let calculations = {
    cart_prices: cart_prices,
    promo_items: promo_items,
    promo: promo,
    credits: credits.map/*to cart items*/((c, i)=>cart[i] ? c : 0),
    credits_used: credits.map/*to cart items*/((c, i)=>cart[i] ? c : 0).reduce/*to credit count*/((t, p)=>t + (p || 0), 0),
    shipping: shipping,
    subtotal: total,
    tax: Math.round(((total + shipping) * tax_rate) * 100) / 100,
    total: Math.round(((total + shipping) * (1.00 + tax_rate)) * 100) / 100
  };
  if (DEBUG) console.log('priceCart calculations: ', calculations);
  return calculations;
}

//only available to current members, no need to deal with enrollment pricing here.
export function priceOneItemCart(itemPrice, credits, customer, requiresShipping=true, tax_group=null) {
  let shipping = requiresShipping ? PREORDER_SHIPPING_COST : 0.00;
  let tax_rate = DEFAULT_TAX_RATE;

  if (customer && customer.tax_rates && customer.tax_rates[tax_group || 1] !== undefined)
    tax_rate = customer.tax_rates[tax_group || 1];

  let credits_used;
  if( credits == 1 ){
    credits_used = 1;
    itemPrice =  0;
    credits = [1,0,0];
  } else {
    credits_used = 0;
    credits = [0,0,0];
  }

  return {
    cart_prices: [itemPrice, 0, 0],
    promo_items: [],
    credits: credits,
    credits_used: credits_used,
    subtotal: itemPrice,
    shipping: shipping,
    tax: Math.round(((itemPrice + shipping) * tax_rate) * 100) / 100,
    total:  Math.round(((itemPrice + shipping) * (1.00 + tax_rate)) * 100) / 100
  };
}


/*function testAdd() {
 console.log('[,13]', addToCart(13, [], [3, 6, 9]));
 console.log('[,13,11]', addToCart(11, [, 13], [3, 6, 9]));
 console.log('[6,13]', addToCart(6, [, 13], [3, 6, 9]));
 console.log('[6,13,3]', addToCart(3, [6, 13], [3, 6, 9]));
 console.log('[6,13,3]', addToCart(23, [6, 13, 3], [3, 6, 9]));
 console.log('[6,13,13]', addToCart(13, [6, 13], [3, 6, 9]));
 console.log('[,12,13]', addToCart(14, [, 12, 13], [3, 6, 9]));
 console.log('[6,12,13]', addToCart(6, [, 12, 13], [3, 6, 9]));
 }

 function testRemove() {
 console.log('[]', removeFromCart(13, [], [3, 6, 9]));
 console.log('[,13]', removeFromCart(11, [, 13], [3, 6, 9]));
 console.log('[11,12]', removeFromCart(6, [6, 11, 12], [3, 6, 9]));
 console.log('[6]', removeFromCart(13, [6, 13], [3, 6, 9]));
 console.log('[6,13,3]', removeFromCart(23, [6, 13, 3], [3, 6, 9]));
 console.log('[6]', removeFromCart(13, [6, 13], [3, 6, 9]));
 console.log('[,13]', removeFromCart(12, [, 12, 13], [3, 6, 9]));
 console.log('[,12]', removeFromCart(13, [, 12, 13], [3, 6, 9]));
 console.log('[6]', removeFromCart(12, [, 12, 6], [3, 6, 9]));
 }

 function testAddO() {
 console.log('[,13]', addToCartO({id: 13}, [], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[,13,11]', addToCartO({id: 11}, [, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[6,13]', addToCartO({id: 6}, [, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[6,13,3]', addToCartO({id: 3}, [{id: 6}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[6,13,3]', addToCartO({id: 23}, [{id: 6}, {id: 13}, {id: 3}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[6,13,13]', addToCartO({id: 13}, [{id: 6}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[,12,13]', addToCartO({id: 14}, [, {id: 12}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[6,12,13]', addToCartO({id: 6}, [, {id: 12}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 }

 function testRemoveO() {
 console.log('[undefined]', removeFromCartO({id: 13}, [], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[undefined,{id:13}]', removeFromCartO({id: 11}, [, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[{id:11},{id:12}]', removeFromCartO({id: 6}, [{id: 6}, {id: 11}, {id: 12}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[{id:6}]', removeFromCartO({id: 13}, [{id: 6}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[{id:6},{id:13},{id:3}]', removeFromCartO({id: 23}, [{id: 6}, {id: 13}, {id: 3}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[{id:6}]', removeFromCartO({id: 13}, [{id: 6}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[undefined,{id:13}]', removeFromCartO({id: 12}, [, {id: 12}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[undefined,{id:12}]', removeFromCartO({id: 13}, [, {id: 12}, {id: 13}], [{id: 3}, {id: 6}, {id: 9}]));
 console.log('[{id:6}]', removeFromCartO({id: 12}, [, {id: 12}, {id: 6}], [{id: 3}, {id: 6}, {id: 9}]));
 }*/

//testAdd();
//testRemove();
//testAddO();
//testRemoveO();



// WEBPACK FOOTER //
// ./src/shared/cart.js